export default "__VITE_ASSET__40829d2d__"